import pair from "../Data/CH_EN_PAIR";

export default (version, name)=>{
    return pair[name][version];
}


// WEBPACK FOOTER //
// ./src/Utility/switchLan.js